/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowKaraokeNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowKaraokeNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Sing Our Hearts Out!",
    "Karaoke Party Time!",
    "Unleash Your Inner Superstar!",
  ],
  title: "Karaoke Night",
  description: "Organize a fun karaoke night.",
  longDescription:
    "Gather your friends for a night of singing and fun! Choose a date, select songs to sing, and plan snacks for the night!",
  emoji: "🎤",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Karaoke Night",
          emoji: "🎤",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have karaoke night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on songs to sing?",
            description: "What songs should we include in our karaoke night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What songs should we choose?",
                emoji: "🎶",
                completeAction: {
                  question: "Decide on snacks?",
                  description: "What snacks should we enjoy while singing?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍿",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Time to Shine!",
    outroDescription:
      "Your karaoke night plans are set! Enjoy singing your favorite songs!",
  },
};
